import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Formik, Field, ErrorMessage } from 'formik';
import { object, string } from 'yup';

import {
  Button,
  ButtonLink,
  ButtonGroup,
  ErrorMsg,
  Heading,
  Label,
  Modal,
  ModalFooter,
  Overflow,
  Text,
  WarningNotice,
} from '@studio/legacy-components';
import useToggle from 'next/hooks/use-toggle';
import { SegmentDuplicateNameError } from 'next/entities/segments';

import { FieldInput } from './styled';

export const SaveAsSegmentManager = ({ onSave }) => {
  const [visible, toggleVisible] = useToggle(false);
  const [serverError, setServerError] = useState(null);

  const handleSubmit = async ({ name }, { setErrors }) => {
    try {
      await onSave(name);
      toggleVisible();
    } catch (error) {
      if (error instanceof SegmentDuplicateNameError) {
        setErrors({
          name: `A Segment by the name "${name}" already exists.`,
        });
      } else {
        setServerError(error);
      }
    }
  };

  return (
    <>
      <Modal visible={visible} onClose={toggleVisible}>
        <Heading>Create Segment</Heading>
        <Formik
          validationSchema={object().shape({
            name: string().required('Segment name is required.'),
          })}
          initialValues={{ name: '' }}
          onSubmit={handleSubmit}
        >
          {({ dirty, isValid, isSubmitting, errors }) => (
            <Form>
              <Overflow>
                {serverError && (
                  <WarningNotice>
                    An error occurred while saving your Segment, please try
                    again!
                  </WarningNotice>
                )}
                <Label htmlFor="name">Segment name</Label>
                <Field
                  aria-label="name"
                  as={FieldInput}
                  error={Boolean(errors.name)}
                  name="name"
                  placeholder="e.g. Activated users"
                  type="text"
                />
                <ErrorMessage name="name" component={ErrorMsg} />
              </Overflow>
              <ModalFooter>
                <ButtonGroup right>
                  <Button
                    type="submit"
                    disabled={[!dirty, !isValid, isSubmitting].includes(true)}
                  >
                    Create Segment
                  </Button>
                  <Button kind="secondary" onClick={toggleVisible}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </ModalFooter>
            </Form>
          )}
        </Formik>
      </Modal>
      <Text>
        <ButtonLink onClick={toggleVisible}>Save as Segment</ButtonLink> to use
        this audience for targeting other experiences.
      </Text>
    </>
  );
};

SaveAsSegmentManager.propTypes = {
  onSave: PropTypes.func,
};
